export const  i18n = (string) => {
    let langString = string;
    const transStrings = ( window.WPVUE &&  window.WPVUE.strings ) ? window.WPVUE.strings : false;
    if(transStrings){
        const tmp = langString.toLowerCase()
        if(transStrings[tmp]){ langString = transStrings[tmp] }
    }

    return langString
}

/**
 * unction is removing last slash from string
 * @param {*} link  slug
 * 
 */
export const trimLink = (link) => {
    if(!link) return ''
    const re = new RegExp(/^\/|\/$/g)
    return link.replace(re, '')
  }

export const vimeoID = (url) => {
    const vimeo_Reg = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(vimeo_Reg)
    let vimeoVideoId = null
    if(match && match[3]){
        vimeoVideoId = match[3]
    }
    return vimeoVideoId
}

export const hasClass = (el, className) => {
    if (el.classList)
        return el.classList.contains(className);
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

export const addClass = (el, className) => {
    if (el.classList)
        el.classList.add(className)
    else if (!hasClass(el, className))
        el.className += " " + className;
}

export const removeClass = (el, className) => {
    if (el.classList)
        el.classList.remove(className)
    else if (hasClass(el, className))
    {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
}


export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}


export const postTypeName = name => {
    const WPVUE = window.WPVUE;
    if(!WPVUE && WPVUE.strings) return name;
    return WPVUE.strings[name] || name
}

/**
 * Sort array of objects based on another array
 * https://gist.github.com/ecarter/1423674
 */

export const mapOrder = (array, order, key) => {
    array.sort((a, b) => {
      const A = a[key];
      const B = b[key];
      return order.indexOf(A) > order.indexOf(B) ? 1 : -1;
    });
    return array;
  }

/***
 * Format otuput array of elements lik
 * Element, some other or another
 */
export const formatOutputValues = (values, last = 'og') => {
    if(values && values.length){
        const test = values.filter(e=> e ? true : false)
        const elements = test.map((e, i) =>{
            return (i !==  0) ? e.toLowerCase() : capitalize(e);
        })
        return elements.join(', ').replace(/, ([^,]*)$/, ' '+last+' $1')
    }else{
        return '';
    }
    
}

export const getCookie = (cname) => {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export const  setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    const expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}